import {Component, EventEmitter, OnInit, Output} from '@angular/core';
import {ActivatedRoute, Router} from "@angular/router";
import {CustomMessageService, UtilService, ResponseHttpError, ResponseHttpSuccess} from "library";
import {RequestService} from "projects/store/src/app/services/api/v1/request.service";
import {PathNavigationService} from 'projects/store/src/app/services/api/v1/path-navigation.service';
import {environment} from "projects/store/src/environments/environment";
import {HttpStatusCode} from "@angular/common/http";
import {TrafficSource} from "projects/store/src/app/enums/traffic-source.enum";
import {SalesWorkflow} from "projects/store/src/app/enums";


enum Step {
  regions = 'regions',
  stores = 'stores',
}
@Component({
  selector: 'app-sales-store',
  templateUrl: './sales-store.component.html'
})
export class SalesStoreComponent implements OnInit{
  requestId: any;
  path!: string;
  visibleFiltersModal = false;
  storeList: any[] = [];
  storeListByRegion: any = [];
  regions: any = [];
  searchTerm: any;
  step = Step.regions;
  selectedRegion = 'Todas';
  categoryId: any;
  first = 0;
  country = environment.global.country
  request: any;
  flowCode: string;
  @Output() nextStepEvent = new EventEmitter();
  @Output() gotoStepEvent = new EventEmitter();

  constructor(private requestService: RequestService, private route: ActivatedRoute,
              private utilService: UtilService, private router: Router,
              private customMessageService: CustomMessageService,
              private pathNavigationService: PathNavigationService) {
    this.requestId = this.route.snapshot.params['request_id'];
    this.path = this.route.snapshot.params['path'];
    this.flowCode = this.route.snapshot.params['flow_code'];
    this.route.queryParams.subscribe(params => {
      this.categoryId = params['category_id'];
    });
    this.request = this.requestService.request;

  }

  ngOnInit() {
    this.load();

  }

  load(){
    this.utilService.enablePageLoading();
    if(this.request.source === TrafficSource["store"]) {
      this.onNextStep()
    }else{
      this.getList()
    }
  }

  getList() {
    this.requestService.getStoresList(this.requestId).subscribe({
      next: ( resp: ResponseHttpSuccess ) => {
        if (resp.status === HttpStatusCode.Ok) {
          this.storeList = resp.body.data.list;
          this.storeListByRegion = [...this.storeList];
          this.onExtractRegions(this.storeList)
        }else{
          this.customMessageService.responseNoticeHandler(resp);
        }
        this.utilService.disablePageLoading();
      },
      error: ( resp: ResponseHttpError ) => {
        this.utilService.disablePageLoading();
        this.customMessageService.responseNoticeHandler(resp);
      }
    });
  }

  onExtractRegions(storeList: any) {
    const regionsTemp: string[] = [];

    storeList.forEach((store: any) => {
      const regionExist = regionsTemp.includes(store.region);
      if (!regionExist) {
        regionsTemp.push(store.region);
      }
    });

    regionsTemp.sort((a: string, b: string) => a.localeCompare(b));


    this.regions = [
      { label: 'Todas', value: 'Todas' },
      ...regionsTemp.map(region => ({ label: region, value: region }))
    ];
  }

  onPageChange(event: any) {
    this.first = event.first;
  }

  applyFilters() {
    const region = this.selectedRegion;
    const search = this.searchTerm?.toLowerCase().trim() || '';

    this.storeListByRegion = this.storeList.filter(store => {
      const matchesRegion = region === 'Todas' || store.region === region;
      const matchesSearch = !search || (
        store.name?.toLowerCase().includes(search) ||
        store.address?.toLowerCase().includes(search) ||
        store.region?.toLowerCase().includes(search)
      );

      return matchesRegion && matchesSearch;
    });

    this.first = 0;
  }



  onRegionSelected(region: any) {
    console.log(region)
    this.selectedRegion = region;
    this.applyFilters();
  }

  onCloseFilterModal() {
    this.visibleFiltersModal = false;
  }

  onSearchStore() {
    this.applyFilters();
  }


  onReturnLabelDirection(store: any){
    return `${store.address}, ${store.region}`;
  }

  onSelected(store: any) {
    this.utilService.enablePageLoading();

    const data = { store };
    this.requestService.update(this.requestId, data).subscribe({
      next: (resp: ResponseHttpSuccess)=> {
        if(resp.status === HttpStatusCode.NoContent) {
          this.onNextStep()
        }else{
          this.customMessageService.responseNoticeHandler(resp);

        }
      },
      error: (error: ResponseHttpError) => {
        if ( error.status === HttpStatusCode.Locked) {
          this.handleRequestLocked(error as any);
        }else{
          this.customMessageService.responseNoticeHandler(error);
        }
      }
    });
  }

  onNextStep() {
    this.nextStepEvent.emit();
  }

  onGotoStep(stepCode: string) {
    this.utilService.enablePageLoading();
    this.gotoStepEvent.emit(stepCode);
  }


  private handleRequestLocked(resp: any): void {
    const messageError = resp.error?.message ?? 'Solicitud no disponible';
    const attemptedUrl = this.getCurrentUrl();
    const state = { attemptedUrl, messageError };

    this.pathNavigationService.navigateToRequestNotAvailable(this.flowCode, state);
  }

  getCurrentUrl(): string {
    return window.location.href;
  }
  protected readonly environment = environment;
  protected readonly Step = Step;
}
